import roundToTwoDecimals from "@Number/roundToTwoDecimals";
import {defaultMovementWeightConstant} from "@Features/slider/features/slider/constants/defaultMovementWeightConstant";

/**
 * Single source of truth for calculating user movement
 */
export default function calculateMoveDistance(prevX: number, newX: number) {
    return roundToTwoDecimals((newX - prevX) * defaultMovementWeightConstant)
}